<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
   <b-container fluid v-bind:class="[{ busy: busy }, 'opacity-transition']">
      <pb-spinner v-if="busy"/>
      <b-row class="mb-2">
         <b-col>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="10"
                aria-controls="my-table"
            ></b-pagination>
         </b-col>
         <b-col>
            <b-form inline class="float-right">
               <b-input-group>
                  <b-input-group-prepend is-text><i class="fal fa-search"></i></b-input-group-prepend>
                  <b-form-input size="sm" v-debounce:500="onFilter" v-model="filterUsers"
                                placeholder="Search User"
                                class="mb-2 mr-sm-2 mb-sm-0"/>
               </b-input-group>
               <b-button @click="resetUserToEdit" variant="primary" v-b-modal.editModalUser
                         class="btn-sm">Add User
                  <i
                      class="mdi mdi-add usersmanagement__add-icon"
                  ></i>
               </b-button>
            </b-form>
         </b-col>
      </b-row>
      <b-row>
         <b-col>
            <b-table responsive striped hover small
                     :items="userProvider"
                     :fields="userFields"
                     :filter="filterString"
                     :per-page="10"
                     ref="userTable"
                     :current-page="currentPage">
               <template v-slot:cell(roles)="row">
                  <span v-bind:key="role.id" v-for="(role) in row.item.roles">{{ role.name }}<br/></span>
               </template>
               <template v-slot:cell(customerShops)="row">
                        <span v-bind:key="item.id"
                              v-for="(item) in row.item.customerShopList">{{ item.webName }}<br/></span>
               </template>
               <template v-slot:cell(externalId)="row">
                  <i v-if="row.item.externalId"
                     class="fas fa-check-circle text-success"></i>
                  <i v-else class="fas fa-times-circle text-danger"></i>
               </template>
               <template v-slot:cell(confirmationSent)="row">
                  <i v-if="row.item.confirmationSent"
                     class="fas fa-check-circle text-success"></i>
                  <i v-else class="fas fa-times-circle text-danger"></i>
               </template>
               <template v-slot:cell(Actions)="row">
                  <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                     <template v-slot:button-content>
                        <i class="fal fa-ellipsis-v-alt"></i>
                     </template>
                     <b-dropdown-item v-b-modal.editModalUser @click.native="setUserToEdit(row.item)">
                        <i class="fal mr-2 fa-fw fa-user-edit"></i> Edit
                     </b-dropdown-item>
                     <b-dropdown-item @click.native="migrateUser(row.item)">
                        <i class="fal mr-2 fa-fw fa-file-export"></i> Diamond Export
                     </b-dropdown-item>
                     <b-dropdown-item v-b-modal.userFavoritesModal @click.native="userForFavorites = row.item">
                        <i class="fal mr-2 fa-fw fa-heart"></i> User Favorites
                     </b-dropdown-item>
                     <b-dropdown-item @click.native="confirmUser(row.item)">
                        <i class="fal mr-2 fa-fw fa-envelope"></i> Confirmation E-Mail
                     </b-dropdown-item>
                     <b-dropdown-item @click.native="sendOrdersMail(row.item)">
                        <i class="fal mr-2 fa-fw fa-envelope"></i> Send Orders Notification Mail
                     </b-dropdown-item>
                     <b-dropdown-divider></b-dropdown-divider>
                     <b-dropdown-item @click.native="setUserToDelete(row.item)">
                        <i class="fal mr-2 fa-fw fa-trash-alt text-danger"></i> Delete
                     </b-dropdown-item>
                  </b-dropdown>
               </template>
            </b-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="10"
                aria-controls="my-table"
            ></b-pagination>
         </b-col>
      </b-row>

      <edit-modal-favorites :id="'userFavoritesModal'" :user="userForFavorites"/>


      <!-- Edit modal User -->
      <edit-modal-user
          :id="'editModalUser'"
          :title="editModalUserTitle"
          @ok="addOrUpdate"
          @cancel="cancelEditUser"
          :roles="roles"
          :customerShops="customerShopCategoryList"
          :userToEdit="userToEdit"
      />
      <!-- Delete Confirmation modal for User -->
      <delete-modal
          :id="'deleteModalUser'"
          @ok="deleteUser"
          @cancel="cancelDeleteUser"
          :deleteModalText="deleteModalUserText"
      />
   </b-container>
</template>

<script>
// @ is an alias to /src
import {mapState, mapActions, mapGetters} from "vuex";
import UserApi from "@shared/_api/user";
import DeleteModal from "../components/DeleteModal";
import EditModalUser from "../components/EditModalUser";
import EditModalFavorites from "@client/src/components/EditModalFavorites";
import {HTTP} from "@shared/_helpers/http";

export default {
   name: "usersTable",
   components: {
      "delete-modal": DeleteModal,
      "edit-modal-user": EditModalUser,
      "edit-modal-favorites": EditModalFavorites
   },
   data: function () {
      return {
         currentPage: 1,
         totalRows: 1,
         userToDelete: null,
         userToEdit: {
            firstName: null,
            lastName: null,
            company: null,
            street: null,
            zipCode: null,
            city: null,
            countryId: null,
            email: '',
            roles: null,
            id: null,
            externalId: null,
            externalAccountType: null,
            supplierId: null
         },
         userForFavorites: null,
         addModalUserTitle: 'Add User',
         filterUsers: '',
         filterString: '',
         isFiltering: false,
         busy: false
      };
   },
   mounted() {
      // Set the initial number of items
      this.busy = true;
      Promise.all([this.fetchRoles(), this.fetchCustomerCategoryList()]).then(() => {

      }).finally(() => {
         this.busy = false;
      });
   },
   computed: {
      ...mapState("usersManagement", ["userFields", "editUser", "users"]),
      ...mapGetters("usersManagement", ["usersArray", "userById"]),
      ...mapState("rolesManagement", ["roles"]),
      ...mapState("category", ["customerShopCategoryList"]),
      deleteModalUserText() {
         if (this.userToDelete) {
            return (
                "Are you sure you want to delete the user " +
                this.userToDelete.lastName +
                " " +
                this.userToDelete.firstName +
                " ?"
            );
         }
         return "";
      },
      editModalUserTitle() {
         if (this.userToEdit) {
            return (
                this.userToEdit.firstName +
                " " +
                this.userToEdit.lastName
            );
         }
         return "";
      }
   },
   methods: {
      ...mapActions("usersManagement", ["deleteUserById", "updateUserById", "addUserViaAdmin", "fetchUserById"]),
      ...mapActions('rolesManagement', ['fetchRoles']),
      ...mapActions('category', ['fetchCustomerCategoryList']),
      userProvider(ctx, callback) {
         let items = [];
         this.busy = true;
         UserApi.fetchAll(ctx.currentPage, ctx.perPage, ctx.filter)
             .then(data => {
                const items = data.paginatedItems;
                this.totalRows = data.total;
                callback(items)
             })
             .catch(() => {
                callback([])
             }).finally(() => {
            this.busy = false;
         });

            return items || [];
        },
        filterFunc(userRow, filterProp) {
            if (!filterProp) {
                return true;
            }

            let propArr = [],
                searchString = filterProp.toLowerCase();

            if (userRow.email) {
               propArr.push(userRow.email.toLowerCase());
            }

            if (userRow.firstName) {
               propArr.push(userRow.firstName.toLowerCase());
            }

            if (userRow.lastName) {
               propArr.push(userRow.lastName.toLowerCase());
            }

            if (userRow.roles && userRow.roles.length > 0) {
               let roles = userRow.roles;
               for (let i = 0; i < roles.length; i++) {
                  if (roles[i].name) {
                     propArr.push(roles[i].name.toLowerCase());
                  }
               }
            }

            for (let i = 0; i < propArr.length; i++) {
               if (propArr[i].indexOf(searchString) !== -1) {
                  return true;
               }
            }

            return false;
        },
        onFilter() {
            this.filterString = this.filterUsers;
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1
        },
        deleteUser() {
            if (this.userToDelete) {
                this.busy = true;
                this.deleteUserById({id: this.userToDelete.id}).finally(() => {
                    this.busy = false;
                });
                this.userToDelete = null;
            }
        },
        cancelDeleteUser() {
            this.userToDelete = null;
        },
        setUserToDelete(user) {
            this.userToDelete = user;
            this.$bvModal.show('deleteModalUser');
        },
        addOrUpdate(user) {
            const roles = this.roles;
            if (user.id) {
                user.roles = user.roles.map(role => ({id: role}));
                user.customerShopList = null;
                this.busy = true;
                if (user.roles) {
                    user.roles = user.roles.map(role => {
                        return roles.find(el => el.id === role.id)
                    })
                }

            UserApi.update(user).then(() => {
               this.$refs.userTable.refresh()
            }).catch(error => {
               console.log(error)
            }).finally(() => {
               this.busy = false;
            });

         } else {
            delete user.id;
            this.busy = true;

            if (user.roles) {
               user.roles = user.roles.map(role => {
                  return roles.find(el => el.id === role);
               })
            }
            UserApi.add(user).then(() => {
               this.$refs.userTable.refresh()
            }).catch(error => {
               console.log(error)
            }).finally(() => {
               this.busy = false;
            });
         }
         this.resetUserToEdit();
      },
      cancelEditUser() {
         this.resetUserToEdit();
      },
      migrateUser(user) {
         this.busy = true;
         UserApi.migrateUser(user.id).then(() => {
            this.$bvToast.toast(`User was successfully migrated.`, this.$toastSuccess);
         }).catch(() => {
            this.$bvToast.toast(`An error occured.`, this.$toastDanger);
         }).finally(() => {
            this.busy = false;
         });
      },
      confirmUser(user) {
         this.busy = true;
         UserApi.confirmUser(user.id).then(() => {
            this.$bvToast.toast(`E-Mail was successfully sent.`, this.$toastSuccess);
            this.$refs.userTable.refresh();
         }).catch(() => {
            this.$bvToast.toast(`An error occured.`, this.$toastDanger);
         }).finally(() => {
            this.busy = false;
         });
      },
      sendOrdersMail(user) {
         this.busy = true;
         HTTP.post(`/subscription/order-notification/${user.id}`)
             .then(() => {
                this.$bvToast.toast(`E-Mail was successfully sent.`, this.$toastSuccess);
                this.$refs.userTable.refresh();
             }).catch(() => {
            this.$bvToast.toast(`An error occured.`, this.$toastDanger);
         }).finally(() => {
            this.busy = false;
         });
      },
      selectFavorites(user) {
         this.userFavorites = JSON.parse(JSON.stringify(user));
      },
      setUserToEdit(user) {
         this.userToEdit = JSON.parse(JSON.stringify(user));
         if (this.userToEdit && this.userToEdit.roles) {
            this.userToEdit.roles = this.userToEdit.roles.map(role => role.id);
         }
      },
      resetUserToEdit() {
         this.userToEdit = {
            firstName: null,
            lastName: null,
            email: null,
            company: null,
            street: null,
            zipCode: null,
            city: null,
            groups: null,
            roles: [],
            countryId: null,
            id: null,
            externalId: null,
            externalShopCategoryId: [],
            externalAccountType: null,
            newPassword: null
         };
      },
      add() {
         this.resetUserToEdit();
         this.$bvModal.show('editModalUser');
      }
   }
};
</script>
